import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateVenue } from "~pages/Venues/types/upsertVenue.ts";
import type { Venue, VenueResponse } from "~types/venue.ts";

export const useCreateVenue = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<Venue, Error, CreateVenue>({
    mutationFn: async (data) => {
      const response = await request<VenueResponse>(`${sport}/o/${organizationId}/venues`, {
        method: "POST",
        body: data,
      });

      return response?.data?.[0];
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["venues", sport, organizationId] });
    },
  });
};
